import { messagesRead, selectPublicChatMessageIds } from 'features/chat/chatSlice';
import { ChatMessageId } from 'features/chat/types';
import { put, select } from 'redux-saga/effects';

export function* readPublicChatSaga() {
  const publicIds: ChatMessageId[] = yield select(selectPublicChatMessageIds);
  yield put(messagesRead({ messages: publicIds, chat: 'public' }));
}
